<!-- <p *ngIf="userData.status === 'IA'" style="text-align: center;
color: #870606;
font-size: large;
background: #f2acac;
border-radius: 10px;">Payment Method Failed: Your payment method could not be processed. Please update your payment details to activate your account and display your deals to customers.</p> -->

<div *ngIf="userData.status === 'IA' && isCharge" class="error-container">
  <div class="error-icon">⚠️</div>
  <div class="error-text">
    <strong>🔴 {{placeHolders['MSG_PAYMENT_ALERT_1']}} </strong><br>
    {{placeHolders['MSG_PAYMENT_ALERT_2']}}
  </div>
</div>

<!-- <div *ngIf="showModal" class="modal-backdrop-blur"></div>

<div class="modal fade show d-block " tabindex="-1" *ngIf="showModal">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Funds</h5>
        <button type="button" class="btn-close" (click)="closeAddFunds()"></button>
      </div>

      <div class="modal-body">
        <form>

          <div class="form-group mb-3">
            <label class="form-label">Name</label>
            <input type="text" class="form-control" [(ngModel)]="customerName" name="name" />
          </div>

          <div class="form-group mb-3">
            <label class="form-label">Email</label>
            <input type="text" class="form-control" [(ngModel)]="customerEmail" name="email" />
          </div>

          <div class="form-group mb-3">
            <label class="form-label">Amount</label>
            <input type="number" class="form-control" [(ngModel)]="amount" name="amount" />
          </div>

          <div class="form-group mb-3">
            <label class="form-label">Credit Card</label>
            <div #cardElement class="stripe-card form-control p-2"></div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeAddFunds()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="addFunds()">Add</button>
      </div>
    </div>
  </div>
</div> -->
<div *ngIf="showModal" class="modal-backdrop-blur"></div>

<!-- Modal -->
<div class="modal fade show d-block" tabindex="-1" *ngIf="showModal">
  <div class="modal-dialog modal-md">
    <div class="modal-content shadow-lg border-0 rounded-3">

      <!-- Header -->
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title d-flex align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-wallet2 me-2"
            viewBox="0 0 16 16">
            <path
              d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
          </svg> {{placeHolders['LBL_WALLET_POP_UP_ADD_FUND']}}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="closeAddFunds()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <!-- Wallet Graphic / Info -->
        <div class="text-center mb-4">
          <i class="bi bi-credit-card-2-front display-4 text-primary"></i>
          <!-- <p class="text-muted mt-2 mb-0">
            Securely add funds to your account using your card.<br>
            "We will not save you card details"
          </p> -->
          <p>
            {{placeHolders['LBL_WALLET_POPUP_TITLE']}}<br>
            <small>{{placeHolders['LBL_WALLET_POPUP_TITLE_2']}}</small>
          </p>
        </div>

        <form class="px-2">
          <!-- Name -->
          <div class="form-group mb-3">
            <label class="form-label fw-semibold">{{placeHolders['LBL_ADDFUND_NAME']}}</label>
            <input type="text" class="form-control shadow-sm" [(ngModel)]="customerName" name="name"
              placeholder="Enter cardholder name" />
          </div>

          <!-- Email -->
          <div class="form-group mb-3">
            <label class="form-label fw-semibold">{{placeHolders['LBL_ADDFUND_EMAIL']}}</label>
            <input type="email" class="form-control shadow-sm" [(ngModel)]="customerEmail" name="email"
              placeholder="Enter your email address" />
          </div>

          <!-- Amount -->
          <div class="form-group mb-3">
            <label class="form-label fw-semibold">{{placeHolders['LBL_ADDFUND_AMOUNT']}}</label>
            <div class="input-group shadow-sm">
              <span class="input-group-text bg-light">$</span>
              <input #amountCtrl="ngModel" type="number" min="10" class="form-control" [(ngModel)]="amount"
                name="amount" placeholder="Enter amount to add" />
            </div>
            <!-- Validation messages -->
            <div *ngIf="amountCtrl.invalid && amountCtrl.touched" class="text-danger mt-1 small">
              <div *ngIf="amountCtrl.errors?.['required']">
                Amount is required.
              </div>
              <div *ngIf="amountCtrl.errors?.['min']">
                Minimum amount must be $10.
              </div>
            </div>
          </div>

          <!-- Card -->
          <div class="form-group mb-3">
            <label class="form-label fw-semibold">{{placeHolders['LBL_ADDFUND_CARD']}}</label>
            <div #cardElement class="stripe-card form-control p-3 shadow-sm"></div>
          </div>
        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer d-flex justify-content-between">
        <button type="button" class="btn btn-outline-secondary" (click)="closeAddFunds()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-x-circle-fill me-1" viewBox="0 0 16 16">
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
          </svg> {{placeHolders['LBL_ADDFUND_CANCEL']}}
        </button>
        <button type="button" class="btn btn-success" [disabled]="!amountCtrl.valid" (click)="addFunds()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-plus-circle me-1" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
            <path
              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
          </svg> {{placeHolders['LBL_ADDFUND_BTN']}}
        </button>
      </div>
    </div>
  </div>
</div>



<form [formGroup]="dashboardForm">
  <div>
    <div class="div-27 row">
      <div class="div-28 col-md-10">
        <!-- <div class="div-29">Hi John Doe</div> -->
        <!-- <div class="div-30">Deals Dashboard</div> -->
        <div class="div-30"> {{placeHolders['dashboard_title']}} <svg matTooltip="Reload" matTooltipPosition="right"
            (click)="reload()" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512">
            <path fill="#306e33"
              d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208s208-93.31 208-208S370.69 48 256 48m120 190.77h-89l36.88-36.88l-5.6-6.51a87.38 87.38 0 1 0-62.94 148a87.55 87.55 0 0 0 82.42-58.25l5.37-15.13l30.17 10.67l-5.3 15.13a119.4 119.4 0 1 1-112.62-159.18a118.34 118.34 0 0 1 86.36 36.95l.56.62l4.31 5L376 149.81Z" />
          </svg></div>

      </div>


      <div class="div-31 col-md-2" *ngIf="!userData.final_payment_flag">
        <div class="div-32" (click)="createCampaign()">{{placeHolders['LBL_CREATE_DEAL']}}</div>
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/1a173d72-6ffb-4055-8028-ba2b294272a4?"
          class="img-13" />
      </div>
    </div>
    <!-- *ngIf="isNewUser"  -->
    <div class="mt-4" *ngIf="userData.paymentMode === 'WALLET' && userData.final_payment_flag">
      <!-- Greeting -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h4>{{placeHolders['LBL_WALLET_WELCOME']}} {{dashName}}! 👋</h4>
          <p class="mb-0">{{placeHolders['LBL_WALLET_WHATS_HAPPENING']}} </p>
        </div>
        <!-- <span class="badge bg-light text-dark border">
          <i class="bi bi-graph-up-arrow me-1 text-success"></i> +12% from last month
        </span> -->
        <div class="div-31 col-md-2">
          <div class="div-32" (click)="createCampaign()">{{placeHolders['LBL_CREATE_DEAL']}}</div>
          <img loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/1a173d72-6ffb-4055-8028-ba2b294272a4?"
            class="img-13" />
        </div>
      </div>

      <!-- Wallet Card -->
      <div class="card shadow-sm border-1" style="background-color: #EFF5FF;border:1px solid skyblue;">
        <div class="card-body p-4">
          <!-- Header Row -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 class="fw-bold mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-wallet2"
                  viewBox="0 0 16 16">
                  <path
                    d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
                </svg>{{placeHolders['LBL_PREPAID_BALANCE']}}
              </h5>
              <!-- <small class="">Your current financial overview</small> -->
            </div>
            <button class="btn btn-primary btn-sm" type="button" (click)="openAddFunds()"
              style="background: #052a36;font-size: large;">
              <i class="bi bi-plus-lg me-1"></i>{{placeHolders['LBL_BTN_ADD_FUNDS']}}
            </button>
          </div>

          <!-- Balance Info -->
          <div class="row" style="text-align: center;font-size: x-large;">
            <div class="col-md-4">
              <p class="text-success mb-1 fw-semibold">
                <i class="bi bi-currency-dollar me-1"></i> {{placeHolders['LBL_WALLET_CURRENT_BAL']}}
              </p>
              <h5 class="fw-bold text-success" style="font-size: larger;">
                ${{ availableBalance || 0 }}
              </h5>
            </div>

            <div class="col-md-4">
              <p class="text-danger mb-1 fw-semibold">
                <i class="bi bi-lock-fill me-1"></i>  {{placeHolders['LBL_WALLET_ALLOCATED_BAL']}}
              </p>
              <h5 class="fw-bold text-danger" style="font-size: larger;">
                ${{ reservedBalance || 0 }}
              </h5>
            </div>

            <div class="col-md-4">
              <p class="text-primary mb-1 fw-semibold">
                <i class="bi bi-cash-coin me-1"></i>{{placeHolders['LBL_WALLET_AVAILABLE_BAL']}}
              </p>
              <h5 class="fw-bold text-primary" style="font-size: larger;">
                ${{ availableForDeals | number:'1.2-2' }}
              </h5>
            </div>
          </div>
          <!-- 🔔 Low Balance Alert -->
          <div *ngIf="(availableBalance || 0) <= 10" class="alert alert-danger mt-3 py-2 px-3">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
           {{placeHolders['LBL_ADDFUND_PLACEHOLDER1']}}
          </div>
          <ng-template #noWallet>
            <p>No wallet data available.</p>
          </ng-template>

          <!-- Progress Bar -->
          <!-- <div>
            <div class="d-flex justify-content-between mb-1">
              <small class="">Available percentage:</small>
              <small class="fw-semibold">80.1%</small>
            </div>
            <div class="progress" style="height: 8px;">
              <div class="progress-bar bg-primary" role="progressbar" style="width: 80.1%;" aria-valuenow="80.1"
                aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div> -->
          <div *ngIf="wallet?.data">
            <div class="d-flex justify-content-between mb-1">
              <small>{{placeHolders['LBL_AVAIBLE_PERCENTAGE']}}</small>
              <small class="fw-semibold">{{ getAvailablePercentage() | number:'1.1-1' }}%</small>
            </div>
            <div class="progress" style="height: 8px;">
              <div class="progress-bar bg-primary" role="progressbar" [style.width.%]="getAvailablePercentage()"
                [attr.aria-valuenow]="getAvailablePercentage()" aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="mt-4">
      <div class="row g-3 align-items-end">


        <!-- Date Range Filter -->
        <!-- <div class="col-md-2">
          <label for="dateRange" class="form-label filterLabel">Date Range</label>
          <select class="form-select" id="dateRange">
            <option selected disabled>Select Range</option>
            <option value="7">Last 7 Days</option>
            <option value="15">Last 15 Days</option>
            <option value="30">Last Month</option>
            <option value="90">Last 3 Months</option>
            <option value="custom">Custom</option>
          </select>
        </div> -->


        <!-- Date Range Dropdown -->
        <!-- <div class="col-md-2">
          <label for="dateRange" class="form-label">{{placeHolders['LBL_CUSTOM_1']}}</label>
          <select class="form-select" [(ngModel)]="selectedRange" (change)="onRangeChange()"
            [ngModelOptions]="{standalone: true}">
            <option value="7">{{placeHolders['Filter_last_week']}}</option>
            <option value="15">{{placeHolders['Filter_last_15']}}</option>
            <option value="30">{{placeHolders['Filter_last_month']}}</option>
            <option value="90">{{placeHolders['Filter_3_Month']}}</option>
            <option value="custom">{{placeHolders['Filter_Custom']}}</option>
          </select>
        </div> -->

        <!-- From Date -->
        <div class="col-md-2">
          <label class="form-label">{{placeHolders['Date_From']}}:</label>
          <input class="form-control" style="border: 1px solid #b1b7c1 !important;" placeholder="yyyy-mm-dd"
            name="fromDate" ngbDatepicker [(ngModel)]="fromDate1" [ngModelOptions]="{standalone: true}"
            #fromDp="ngbDatepicker" [container]="'body'" (click)="fromDp.open()" />
        </div>

        <!-- To Date -->
        <div class="col-md-2">
          <label class="form-label">{{placeHolders['Date_To']}}:</label>
          <input class="form-control" style="border: 1px solid #b1b7c1 !important;" placeholder="yyyy-mm-dd"
            name="toDate" ngbDatepicker [(ngModel)]="toDate1" [ngModelOptions]="{standalone: true}"
            #toDp="ngbDatepicker" [container]="'body'" (click)="toDp.open()" />
        </div>




        <!-- Status Filter -->
        <div class="col-md-2">
          <label for="statusFilter" class="form-label filterLabel">{{placeHolders['LBL_STATUS']}}</label>
          <select class="form-select" id="statusFilter" [(ngModel)]="status1" [ngModelOptions]="{standalone: true}">
            <option selected disabled>{{placeHolders['LBL_CUSTOM_3']}} {{placeHolders['LBL_STATUS']}}</option>
            <option value="">{{placeHolders['LBL_FILTER_ALL']}}</option>
            <option value="A">{{getStatusLabel('A')}}</option>
            <option value="S">{{getStatusLabel('S')}}</option>
            <option value="E">{{getStatusLabel('E')}}</option>
            <option value="D">{{getStatusLabel('D')}}</option>
            <option value="P">{{getStatusLabel('P')}}</option>
            <option value="C">{{getStatusLabel('C')}}</option>
          </select>
        </div>


        <!-- Budget Filter -->
        <!-- <div class="col-md-2">
          <label for="budgetFilter" class="form-label filterLabel">{{placeHolders['LBL_BUDGET']}}</label>
          <select class="form-select" id="budgetFilter" [(ngModel)]="budget1" [ngModelOptions]="{standalone: true}">
            <option selected disabled>{{placeHolders['LBL_CUSTOM_2']}}</option>
            <option value="">{{placeHolders['LBL_FILTER_ALL']}}</option>
            <option value="0">$0 - $1000</option>
            <option value="1">$1001 - $9999</option>
            <option value="2">{{placeHolders['LBL_FILTER_ABOVE']}} $9999</option>
          </select>
        </div> -->

        <!-- Category Filter -->
        <div class="col-md-4">
          <label for="categoryFilter" class="form-label filterLabel">{{placeHolders['LBL_TBL_CATEGORY']}}</label>
          <!-- <select class="form-select" id="categoryFilter">
            <option selected disabled>Select Category</option>
            <option value="Fashion">Fashion</option>
            <option value="Electronics">Electronics</option>
            <option value="Grocery">Grocery</option>
            <option value="Services">Services</option>
          </select> -->
          <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Category'" [data]="allCategory"
            bindLabel="category_type" bindValue="category_id" [(ngModel)]="category"
            [ngModelOptions]="{standalone: true}" (click)="setCategoryValue($event)"
            (onSelect)="onCategoryChange($event)">
          </ng-multiselect-dropdown>
        </div>

        <!-- Charged Filter -->
        <!-- <div class="col-md-2">
          <label for="chargedFilter" class="form-label filterLabel">{{placeHolders['LBL_TBL_ACTUAL_SPENT']}}</label>
          <select class="form-select" id="chargedFilter" [(ngModel)]="charged1" [ngModelOptions]="{standalone: true}">
            <option selected disabled>{{placeHolders['LBL_CUSTOM_3']}} </option>
            <option value="">{{placeHolders['LBL_FILTER_ALL']}}</option>
            <option value="0">$0 - $1000</option>
            <option value="1">$1001 - $9999</option>
            <option value="2">{{placeHolders['LBL_FILTER_ABOVE']}} $9999</option>
          </select>
        </div> -->

        <!-- <div class="row g-1 align-items-end" *ngIf="selectedRange === 'custom'">
          From Date
          <div class="col-md-2" *ngIf="selectedRange === 'custom'">
            <label class="form-label">{{placeHolders['Date_From']}}:</label>
            <input class="form-control" style="border: 1px solid #b1b7c1 !important;" placeholder="yyyy-mm-dd"
              name="fromDate" ngbDatepicker [(ngModel)]="fromDate1" [ngModelOptions]="{standalone: true}"
              #fromDp="ngbDatepicker" [container]="'body'" (click)="fromDp.open()" />
          </div>

          To Date
          <div class="col-md-2" *ngIf="selectedRange === 'custom'">
            <label class="form-label">{{placeHolders['Date_To']}}:</label>
            <input class="form-control" style="border: 1px solid #b1b7c1 !important;" placeholder="yyyy-mm-dd"
              name="toDate" ngbDatepicker [(ngModel)]="toDate1" [ngModelOptions]="{standalone: true}"
              #toDp="ngbDatepicker" [container]="'body'" (click)="toDp.open()" />
          </div>
          Filter Button
          <div class="col-md-2" *ngIf="selectedRange === 'custom'">
            <button (click)="filterDetails()" type="button"
              class="btn btn-success w-100">{{placeHolders['BTN_APPLY_FILTERS']}}</button>
          </div>

        </div> -->

        <!-- Filter Button -->
        <div class="col-md-2" *ngIf="selectedRange === 'custom'">
          <button (click)="filterDetails()" style="background-color: #052a36;color: white;" type="button"
            class="btn btn-success w-100">{{placeHolders['BTN_APPLY_FILTERS']}}</button>
        </div>
      </div>
      <div class="row g-3 align-items-end">
        <div class="col-6 pt-2" style="justify-items: self-start;">
          <div class="div-59">
            <div class="div-60">
              <input type="search" (search)="search()" formControlName="search" autocomplete="off" maxlength="100"
                class="div-61" style="border:none; background-color: transparent ;"
                placeholder="{{placeHolders['LBL_SEARCH_PLACEHOLDER']}}" />
              <!-- <div class="div-61">Search</div> -->
              <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/960e3587b102d32ae26b055144ae7805805584175a9f8744d348d759c2ad8f5e?"
                class="img-22" (click)="search()" type="button" />
            </div>
          </div>
        </div>

      </div>

    </div>


    <div class="div-17" *ngIf="datePickerVisible===true">
      <div class="div-18">
        <!-- <span>From:</span> -->
        <div class="div-21">
          <label style="margin-left: -65px;font-weight: 500;">{{placeHolders['Date_From']}}:</label>
          <Input type="date" min="{{ minDate }}" max="{{ todaysDate }}" (change)="setFromDate($event)"
            onkeydown="return false" placeholder="{{placeHolders['LBL_CUSTOM_3']}}  date"
            style="border: 0px solid transparent;" />
        </div>
      </div>
      <div class="div-23">
        <div class="div-24">
          <!-- <div class="div-25">To</div> -->
          <img loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4bbf3f6be6b4a0c4435de1895467800e2ddd5d0433d0ed53d3fd76dd73608aab?"
            class="img-9" />
        </div>
        <!-- <span>To:</span> -->
        <div class="div-1">
          <label style="margin-left: -30px;font-weight: 500;">{{placeHolders['Date_To']}}:</label>
          <Input type="date" min="{{ minDate }}" max="{{ todaysDate }}" (change)="setToDate($event)"
            onkeydown="return false" placeholder="{{placeHolders['LBL_CUSTOM_3']}}  date"
            style="border: 0px solid transparent;" />
        </div>
      </div>
      <div>
        <button (click)="customOkClick()" class="div-82 mt-2">{{placeHolders['btn_GO']}}</button>
      </div>
    </div>




    <div class="div-44" *ngIf="data">






      <div class="pb-2">
        <!-- Applied Filters -->
        <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
          <span
            *ngIf="selectedStatus || selectedCategory || (selectedRange === 'custom' && fromDate && toDate && showfilterChip) || selectedBudget || selectedCharged">Applied
            Filters:</span>
          <span *ngIf="selectedStatus" class="badge bg-primary px-3 py-2 d-flex align-items-center">
            {{placeHolders['LBL_STATUS']}}:{{ getStatusLabel(selectedStatus) }}
            <button type="button" class="btn-close btn-close-white ms-2" aria-label="Remove"
              (click)="clearFilter('status')"></button>
          </span>

          <span *ngIf="selectedCategory" class="badge bg-success px-3 py-2 d-flex align-items-center">
            Category: {{ selectedCategory }}
            <button type="button" class="btn-close btn-close-white ms-2" aria-label="Remove"
              (click)="clearFilter('category')"></button>
          </span>

          <!-- <span *ngIf="selectedRange && selectedRange !== 'custom'"
      class="badge bg-info px-3 py-2 d-flex align-items-center">
      Date Range: Last {{ selectedRange }} Days
      <button type="button" class="btn-close btn-close-white ms-2" aria-label="Remove"
        (click)="clearFilter('range')"></button>
    </span> -->

          <span *ngIf="selectedRange === 'custom' && fromDate && toDate && showfilterChip"
            class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
            Date: {{ fromDate ? formatDate(fromDate) : 'N/A' }} to {{ toDate ? formatDate(toDate) : 'N/A' }}
            <button type="button" class="btn-close ms-2" aria-label="Remove" (click)="clearFilter('range')"></button>
          </span>

          <span *ngIf="selectedBudget" class="badge bg-secondary px-3 py-2 d-flex align-items-center">
            Budget: {{ getBudgetLabel(selectedBudget) }}
            <button type="button" class="btn-close btn-close-white ms-2" aria-label="Remove"
              (click)="clearFilter('budget')"></button>
          </span>

          <span *ngIf="selectedCharged" class="badge bg-secondary px-3 py-2 d-flex align-items-center">
            Actual Spent: {{ getBudgetLabel(selectedCharged) }}
            <button type="button" class="btn-close btn-close-white ms-2" aria-label="Remove"
              (click)="clearFilter('charge')"></button>
          </span>
        </div>

        <div class="row g-3">
          <!-- Total Deals -->
          <div class="col-12 col-sm-6 col-md-4">
            <div class="card shadow-sm h-100">
              <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-tile">{{placeHolders['LBL_TOTAL_DEALS']}}</small>
                  <h4 class="mb-0 fw-bold">{{this.campaignTotalData?.TOTAL_DEALS}}</h4>
                </div>
                <div class="text-primary fs-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M5 22h14c1.103 0 2-.897 2-2V9a1 1 0 0 0-1-1h-3V7c0-2.757-2.243-5-5-5S7 4.243 7 7v1H4a1 1 0 0 0-1 1v11c0 1.103.897 2 2 2M9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9zm-4 3h2v2h2v-2h6v2h2v-2h2l.002 10H5z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Total Budget -->
          <div class="col-12 col-sm-6 col-md-4">
            <div class="card shadow-sm h-100">
              <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-tile">{{placeHolders['LBL_TOTAL_BUDGET']}}</small>
                  <h4 class="mb-0 fw-bold text-success">${{this.campaignTotalData?.TOTAL_BUDGET}}</h4>
                </div>
                <div class="text-success fs-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8" />
                    <path fill="currentColor"
                      d="M12 11c-2 0-2-.63-2-1s.7-1 2-1s1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3c2 0 2 .68 2 1s-.62 1-2 1c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92c0-1.12-.52-3-4-3" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Spent -->
          <div class="col-12 col-sm-6 col-md-4">
            <div class="card shadow-sm h-100">
              <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-tile">{{placeHolders['LBL_ACTUAL_SPENT']}}</small>
                  <h4 class="mb-0 fw-bold text-danger">${{this.campaignTotalData?.TOTAL_ACTUAL_SPENT}}</h4>
                </div>
                <div class="text-danger fs-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M16 12h2v4h-2z" />
                    <path fill="currentColor"
                      d="M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2M5 5h13v2H5a1.001 1.001 0 0 1 0-2m15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Charged -->
          <!-- <div class="col-12 col-sm-6 col-md-3">
            <div class="card shadow-sm h-100">
              <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-tile">{{placeHolders['LBL_CHARGED']}}</small>
                  <h4 class="mb-0 fw-bold text-info">${{this.campaignTotalData?.TOTAL_SPENT_CHARGED}}</h4>
                </div>
                <div class="text-info fs-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M16 12h2v4h-2z" />
                    <path fill="currentColor"
                      d="M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2M5 5h13v2H5a1.001 1.001 0 0 1 0-2m15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15z" />
                  </svg>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>

    </div>


    <!-- <div class="pt-2 div-17" style="display: flex; justify-content: end;">
      <div class="div-50 col-5 px-2" *ngIf="allCategory && allCategory.length !==0">
        <label style="color: black;font-weight:500;">Category</label> 
        <div>
          <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Select Category'" [data]="allCategory"
            bindLabel="category_type" bindValue="category_id" formControlName="category"
            (click)="setCategoryValue($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="div-50 ">        
        <label style="color: black;font-weight:500;">Status</label> 
        <div>
          <mat-radio-group aria-label="Select an option" formControlName="status">
            <mat-radio-button value="All">All</mat-radio-button>
            <mat-radio-button value="A">Active</mat-radio-button>
            <mat-radio-button value="P">Paused</mat-radio-button>
            <mat-radio-button value="E">Expired</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      
    </div> -->
    <!-- <div>    
    <div class="pt-2" style="float: right;">
      <button class="div-82 px-2" (click) = "onSubmitFilter()" >Go</button>
      <button class="div-100 mx-1" (click) = "onResetFilter()">Reset</button>
    </div>
  </div> -->

    <div class="row pb-1" *ngIf="filterDataForChip">
      <span>
        <label *ngIf="filterDataForChip.status!==''">
          <b> Applied filters: </b>
        </label>
        <button (click)="clearAll()" *ngIf="filterDataForChip.status!==''" class="div-filterbtn">
          Clear all x</button>
        <label *ngIf="filterDataForChip.status!==''" class="div-chip">
          <b>{{placeHolders['LBL_STATUS']}}</b>: {{filterDataForChip.status}} </label>
        <label class="div-chip" *ngIf="filterDataForChip.budget!==''">
          <b>Budget</b>: {{filterDataForChip.budget}}</label>
        <label class="div-chip" *ngIf="filterDataForChip.actualSpent!==''">
          <b>Actual spent</b>: {{filterDataForChip.actualSpent}}</label>
        <span *ngIf="filterDataForChip.category!==[]">
          @for (data of filterDataForChip.category; track data) {
          <label class="div-chip">{{data}}</label>
          }
        </span>
      </span>
    </div>


    <div class="div-55" *ngIf="data.length!==0">


      <div class="table-responsive">
        <table class="custom-table">
          <thead>
            <tr>
              <th style="width: 15%;" (click)="'uuid'">{{placeHolders['LBL_TBL_UUID'] }}</th>
              <th>{{placeHolders['LBL_TBL_PRODUCT_IMG'] }}</th>
              <th style="width: 25%;" (click)="'product_name'">{{ placeHolders['LBL_TBL_NAME'] }}</th>
              <th (click)="'created_date'">{{ placeHolders['LBL_TBL_DATE_CREATED'] }}</th>
              <th (click)="'created_by'">Created By</th>
              <th (click)="'category_type'">{{ placeHolders['LBL_TBL_CATEGORY'] }}</th>
              <th>{{ placeHolders['LBL_TBL_STATUS'] }}</th>
              <th (click)="'budget'">{{ placeHolders['LBL_TBL_BUDGET'] }}</th>
              <th (click)="'total_spent'">{{ placeHolders['LBL_TBL_ACTUAL_SPENT'] }}</th>
              <!-- <th (click)="'spentAlreadyCharged'">{{ placeHolders['LBL_TBL_CHARGED'] }}</th> -->
              <th style="width: 24%;">{{ placeHolders['LBL_TBL_ACTION'] }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data" [class]="row.flash ? 'flash-deal' : 'regular-deal'">
              <td class="text-start">{{ row.uuid }} <span *ngIf="row.flash">⚡</span> </td>
              <td><img [src]="getFullImageUrl(row.product_image)" alt="Image preview" class="product-img" />
              </td>
              <td class="text-start">{{ row.product_name }}</td>
              <td>{{ row.created_date }}</td>
              <td>{{ row.created_by !== '66cddac44bff710516652640' ? 'Merchant' : 'Support' }}</td>
              <td>{{ row.category_type }}</td>
              <td>
                <mat-chip [ngClass]="getStatusClass(row.status)">
                  {{ getStatusLabel(row.status) }}
                </mat-chip>
              </td>
              <td>{{ row.budget }}</td>
              <td>{{ row.total_spent }}</td>
              <!-- <td>{{ row.spentAlreadyCharged }}</td> -->
              <td>
                <div class="action-buttons-grid">
                  <!-- Flash Deal Icon -->
                  <!-- <div class="icon-cell" [class.invisible]="!row.flash">
                    <div class="tooltip-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 48 48">
                        <path fill="#ffc107" d="M33 22h-9.4L30 5H19l-6 21h8.6L17 45z" />
                      </svg>
                      <span class="tooltip-text">Flash Deal</span>
                    </div>
                  </div> -->

                  <!-- Edit Icon -->
                  <div class="icon-cell" [class.invisible]="!shouldShowEditIcon(row.status)">
                    <div class="tooltip-wrapper">
                      <svg (click)="onEdit(row)" xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em"
                        viewBox="0 0 64 64">
                        <path fill="#36849d"
                          d="m59.466 6.317l-1.783-1.784a8.654 8.654 0 0 0-12.234 0L9.419 40.565L2.278 59.237c-.838 2.21.281 3.323 2.484 2.481l18.675-7.134l36.029-36.033c3.381-3.376 3.377-8.853 0-12.234m-22.629 9.486l2.508 2.507l-24.764 24.766l-2.508-2.509zm3.834 3.834l3.695 3.696l-24.763 24.765l-3.695-3.695zM11.026 57.32l-4.342-4.346l4.201-10.941L21.964 53.11zm12.411-5.387l-2.506-2.509l24.762-24.765l2.508 2.509zm26.209-26.21L38.281 14.36l2.827-2.828l11.365 11.363z" />
                      </svg>
                      <span class="tooltip-text">{{ placeHolders['LBL_EDIT'] }}</span>
                    </div>
                  </div>

                  <!-- View Icon -->
                  <div class="icon-cell" [class.invisible]="!shouldShowViewIcon(row.status)">
                    <div class="tooltip-wrapper">
                      <svg (click)="onView(row)" xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em"
                        viewBox="0 0 576 512">
                        <path fill="#36849d"
                          d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
                      </svg>
                      <span class="tooltip-text"> {{ placeHolders['LBL_VIEW'] }}</span>
                    </div>
                  </div>

                  <!-- Create Flash Icon -->
                  <div class="icon-cell">
                    <div class="tooltip-wrapper">
                      <svg (click)="onCreateFlash(row)" xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em"
                        viewBox="0 0 24 24">
                        <path fill="#36849d"
                          d="M11 17H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12v2H4v12h7v-2l4 3l-4 3zm8 4V7H8v6H6V7a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h2v2z" />
                      </svg>
                      <span class="tooltip-text">{{ placeHolders['LBL_COPY_DEAL'] }}</span>
                    </div>
                  </div>

                  <!-- <div class="icon-cell" [class.invisible]="!shouldShowReceiptIcon(row.status)">
                    <div class="tooltip-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" (click)="receiptDownload(row)" width="1.5em"
                        height="1.5em"
                        viewBox="0 0 640 640">
                        <path fill="#36849d"
                          d="M142 66.2C150.5 62.3 160.5 63.7 167.6 69.8L208 104.4L248.4 69.8C257.4 62.1 270.7 62.1 279.6 69.8L320 104.4L360.4 69.8C369.4 62.1 382.6 62.1 391.6 69.8L432 104.4L472.4 69.8C479.5 63.7 489.5 62.3 498 66.2C506.5 70.1 512 78.6 512 88L512 552C512 561.4 506.5 569.9 498 573.8C489.5 577.7 479.5 576.3 472.4 570.2L432 535.6L391.6 570.2C382.6 577.9 369.4 577.9 360.4 570.2L320 535.6L279.6 570.2C270.6 577.9 257.3 577.9 248.4 570.2L208 535.6L167.6 570.2C160.5 576.3 150.5 577.7 142 573.8C133.5 569.9 128 561.4 128 552L128 88C128 78.6 133.5 70.1 142 66.2zM232 200C218.7 200 208 210.7 208 224C208 237.3 218.7 248 232 248L408 248C421.3 248 432 237.3 432 224C432 210.7 421.3 200 408 200L232 200zM208 416C208 429.3 218.7 440 232 440L408 440C421.3 440 432 429.3 432 416C432 402.7 421.3 392 408 392L232 392C218.7 392 208 402.7 208 416zM232 296C218.7 296 208 306.7 208 320C208 333.3 218.7 344 232 344L408 344C421.3 344 432 333.3 432 320C432 306.7 421.3 296 408 296L232 296z" />
                      </svg>
                      <span class="tooltip-text">{{placeHolders['LBL_DOWNLOAD']}} Receipt</span>
                    </div>
                  </div> -->
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>



    <div *ngIf="isNewUser; else noRecords">

      <div class="div-Norecord" *ngIf="data.length===0">
        <div class="div-Norecord2">
          <div class="div-Norecord3">{{placeHolders['LBL_CUSTOM_4']}} </div>
        </div>
      </div>
    </div>
    <ng-template #noRecords>
      <div class="div-Norecord" *ngIf="data.length===0">
        <div>
          <img style="height: 120px; width: 120px;" src="../../../assets/images/createcampaign.png">
          <div class="div-Norecord3" [ngClass]="createrecordtext()">{{placeHolders['LBL_NO_DEALS_CREATED']}}</div>
          <div class="div-centerlabel firsttimeRecord">
            <div class="div-createdeal" (click)="createCampaign()">{{placeHolders['LBL_CREATE_DEAL']}}</div>
            <img loading="lazy" [ngClass]="getDynamicClass()"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/1a173d72-6ffb-4055-8028-ba2b294272a4?"
              class="img-13" />
          </div>
        </div>
      </div>

    </ng-template>

    <div class="row mt-2">
      <div class="col-lg-12 col-md-12 ml-auto mr-auto">
        <div class="float-right">
          <app-pagination *ngIf="recordTotalCount!==0" [totalRecords]="recordTotalCount" [recordsPerPage]="10"
            [activePage]="activePage" (onPageChange)="displayActivePage($event)"></app-pagination>
        </div>
      </div>
    </div>



  </div>
</form>

<div class="popup-overlay" *ngIf="showPopup">
  <div class="popup-card">
    <button class="close-btn" (click)="closePopup()">×</button>

    <div class="card-content">
      <div class="img-side">
        <img [src]="getFullImageUrl(selectedRow.product_image)" alt="Image preview" />
      </div>
      <div class="info-side">
        <h3>{{ selectedRow?.product_name }}</h3> <mat-chip [ngClass]="getStatusClass(selectedRow?.status)">
          {{ getStatusLabel(selectedRow?.status) }}
        </mat-chip>
        <p class="description">{{ selectedRow?.product_description }}</p>
        <p><strong>Discount code: </strong> {{ selectedRow?.coupon_code }}</p>
        <p><strong>Category: </strong> {{ selectedRow?.category_type }}</p>
        <p><strong>Budget: </strong> ${{ selectedRow?.budget }}</p>
        <p><strong>Total Spent: </strong> ${{ selectedRow?.total_spent }}</p>
        <p><strong>Charged: </strong> ${{ selectedRow?.spentAlreadyCharged }}</p>
        <p><strong>Created: </strong> {{ selectedRow?.created_date }}</p>
        <p><strong>Available from: </strong> {{ selectedRow?.available_from | date: 'short'}}</p>
        <p><strong>Available to: </strong> {{ selectedRow?.available_to | date: 'short'}}</p>
      </div>
    </div>
  </div>
</div>


<div class="blur-overlay" *ngIf="showAlert">
  <div class="alert-box">
    <div class="alert-header">
      <h4><i class="bi bi-exclamation-circle-fill text-warning"></i> {{placeHolders['LBL_ALERT_POPUP_TITLE']}}</h4>
    </div>
    <div class="alert-body">
      <p>{{placeHolders['LBL_ALERT_POPUP_MSG']}}<strong>$0.00</strong>.</p>
      <p>{{placeHolders['LBL_ADDFUND_PLACEHOLDER2']}}</p>
    </div>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" style="background-color: #052a36;color: white;" (click)="openAddFunds()">+ {{placeHolders['LBL_ALERT_BTN_ADDFUND']}}</button>
      <button type="button"  class="btn btn-outline-secondary" (click)="closeAlert()">{{placeHolders['LBL_ALERT_BTN_CANCEL']}}</button>
    </div>
  </div>
</div>